import { BaseApi, Environment } from '@nextroll/ar-base-api';

const advertisableApi = new BaseApi('/zeta/v1/advertisable/', {
    environment: (process.env.ENVIRONMENT || 'development') as Environment,
});

export const getDefaultCrm = async (advertisableEid?: string) => {
    if (!advertisableEid) {
        return undefined; // data is not ready; do nothing
    }
    return (await advertisableApi.get('settings', { advertisable_eid: advertisableEid }))?.crm_system;
};

export default advertisableApi;
